import { decodeJwtPayload } from './jwt';

export const DOCS_SESSION_COOKIE = 'fancian_admin_docs';

/**
 * True when a login `redirect` query should load VitePress via a full page
 * navigation instead of React Router (which would hit the SPA catch-all).
 */
export function isDocsRedirectPath(path) {
  if (!path || typeof path !== 'string') return false;
  const pathname = path.split('?')[0];
  return (
    pathname === '/docs' ||
    pathname.startsWith('/docs/') ||
    pathname === '/feature_docs' ||
    pathname.startsWith('/feature_docs/') ||
    pathname === '/backend_docs' ||
    pathname.startsWith('/backend_docs/')
  );
}

function cookieSecureSuffix() {
  return typeof window !== 'undefined' && window.location.protocol === 'https:'
    ? '; Secure'
    : '';
}

export function setDocsSessionCookie(token) {
  if (typeof document === 'undefined') return;
  if (!token) {
    clearDocsSessionCookie();
    return;
  }
  const payload = decodeJwtPayload(token);
  const nowSec = Math.floor(Date.now() / 1000);
  let maxAge = 60 * 60 * 24 * 7;
  if (payload && typeof payload.exp === 'number' && payload.exp > nowSec) {
    maxAge = payload.exp - nowSec;
  }
  document.cookie =
    `${DOCS_SESSION_COOKIE}=${encodeURIComponent(token)}; Path=/; SameSite=Lax; Max-Age=${maxAge}` +
    cookieSecureSuffix();
}

export function clearDocsSessionCookie() {
  if (typeof document === 'undefined') return;
  document.cookie =
    `${DOCS_SESSION_COOKIE}=; Path=/; SameSite=Lax; Max-Age=0` + cookieSecureSuffix();
}
